import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Components/Login/Login";          // your existing login
import Dashboard from "./Components/Home/Home";       // your current Home.js
import AdminUsers from "./Components/Pages/AdminUsers";
import Roles from "./Components/Pages/Roles";
import { isSuperAdmin } from "./Components/Auth/auth";

const Private = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" replace />;
};

const SuperAdminPrivate = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  return isSuperAdmin() ? children : <Navigate to="/dashboard" replace />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={<Private><Dashboard /></Private>}
        />
        <Route
          path="/admin-users"
          element={<SuperAdminPrivate><AdminUsers /></SuperAdminPrivate>}
        />
        <Route
          path="/roles"
          element={<SuperAdminPrivate><Roles /></SuperAdminPrivate>}
        />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
